import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { handleSortableUpdate } from "./concerns/board";
import { AutoScroll } from "./concerns/auto_scroll"


// Connects to data-controller="progress"
export default class extends Controller {

  connect() {
    this.sortabledList = []
    const isMobile = this.#isMobileDevice()

    const options = {
      group: 'assignments',
      handle: ".drag_handle",
      animation: 150,
      delay: 300,
      delayOnTouchOnly: true,
      onStart: this.#onStart.bind(this),
      onEnd: this.#change.bind(this)
    }

    // スマホ版ではSwiper内でのドラッグ対応のためforceFallbackを有効化
    if (isMobile) {
      options.forceFallback = true
      options.fallbackOnBody = true
      options.fallbackTolerance = 5
    }

    Sortable.create(this.element, options)

    // スマホ版ではSwiperBoardControllerがスクロールを管理するためAutoScrollは無効
    if (!isMobile) {
      Object.assign(this, AutoScroll)
      this.initAutoScroll('progress_board')
    }
  }

  disconnect() {
    if (this.disconnectAutoScroll) {
      this.disconnectAutoScroll()
    }
  }

  #isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }

  #onStart() {
    // 触覚フィードバック（対応ブラウザのみ）
    navigator.vibrate?.(15)
  }

  async #change(event) {
    // ドロップ先のリストはタスクがあるのでナロー解除
    const targetWrapper = event.to.closest('.board-list-wrapper')
    if (targetWrapper) {
      targetWrapper.classList.remove('narrow')
    }

    await handleSortableUpdate(event)
  }
}
